export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='#page-top'>
            <i className="fa fa-star"></i>
            noes.arte
            <i className="fa fa-star"></i>
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li className='nav-about'>
              <a href='#about' className='page-scroll'>
                Propuesta
              </a>
            </li>
            <li className='nav-team'>
              <a href='#cursosNew' className='page-scroll'>
                Cursos
              </a>
            </li>
            <li className='nav-portfolio'>
              <a href='#portfolio' className='page-scroll'>
                Articulos
              </a>
            </li>
            <li className='nav-testimonials'>
              <a href='#testimonials' className='page-scroll'>
                Opiniones
              </a>
            </li>
            <li className='nav-contact'>
              <a href='#contact' className='page-scroll'>
                Contacto
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
